import { Separator } from "@chakra-ui/react-v3";
import { SmartCondition } from "@metriport/fhir-sdk";
import { ResourceAnalysis } from "../components/resource-analysis";
import { ResourceTimelineLayout } from "../components/resource-timeline-layout";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { ConditionRowData } from "../tables/condition";
import { ConditionTimelineItem } from "./condition-timeline-item";
import {
  getEndTime,
  getOnsetTime,
} from "../../shared-components/fhir-sections/conditions/table-data";

export type ConditionSidePanelContentProps = {
  data: ConditionRowData;
};

export function ConditionSidePanelContent({ data }: ConditionSidePanelContentProps) {
  const dateRange =
    data.firstSeen !== "-" && data.lastSeen !== "-" && data.firstSeen !== data.lastSeen
      ? `${data.firstSeen} to ${data.lastSeen}`
      : data.lastSeen !== "-"
      ? data.lastSeen
      : data.firstSeen;

  const conditions =
    data.conditions && data.conditions.length > 0 ? data.conditions : [data.originalData];

  // Sort conditions by date (newest first)
  const sortedConditions = [...conditions].sort((a, b) => {
    const dateA = getOnsetTime(a, data.patientDob) ?? getEndTime(a, data.patientDob) ?? "";
    const dateB = getOnsetTime(b, data.patientDob) ?? getEndTime(b, data.patientDob) ?? "";

    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;

    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });

  return (
    <SidePanelLayout title="Condition" subtitle={data.condition} metadata={dateRange}>
      <ResourceAnalysis />

      <Separator borderColor="border" />

      <ResourceTimelineLayout
        title={`Occurrences (${sortedConditions.length})`}
        items={sortedConditions.map((condition, index) => {
          const currentDate =
            getOnsetTime(condition, data.patientDob) ?? getEndTime(condition, data.patientDob);

          return {
            date: currentDate || "",
            content: (
              <ConditionTimelineItem
                key={condition.id || index}
                condition={condition as SmartCondition}
                isFirst={index === 0}
              />
            ),
          };
        })}
      />
    </SidePanelLayout>
  );
}
